module.exports = __webpack_public_path__ + "img/like.1a91e85d.jpg";